import React from "react";
import "../../Styles/Audio.css";
import { useState, useRef } from "react";
import { useEffect } from "react";

const Audio = ({ audioSrc, itemId, audioId, setAudioId }) => {
  const [volumePlayer, setVolumePlayer] = useState(true);
  const [iconPlayer, setIconPlayer] = useState(true);
  const [timePlayer, setTimePlayer] = useState();
  // console.log(timePlayer);
  const refAudio = useRef(null);
  const song = useRef(null);
  const song2 = useRef(null);

  const line = useRef(null);
  const line2 = useRef(null);

  // =============================================

  useEffect(() => {
    if (itemId !== audioId) {
      refAudio.current.pause();
      setIconPlayer(true);
    }
  }, [audioId]);

  const playPause = () => {
    setAudioId(itemId);
    if (refAudio.current.paused) {
      refAudio.current.play();
      setIconPlayer(false);
    } else {
      refAudio.current.pause();
      setIconPlayer(true);
    }
  };

  const changeVolume = () => {
    if (refAudio.current.volume == 1) {
      refAudio.current.volume = 0;
      setVolumePlayer(false);
    } else {
      refAudio.current.volume = 1;
      setVolumePlayer(true);
    }
  };

  // var pppOfSong = refAudio?.current?.currentTime / refAudio?.current?.duration;
  // console.log(song.current.offsetWidth * pppOfSong);

  // console.log(pppOfSong);
  // console.log(line);

  var lineWidth = "";
  // console.log(song);

  const updateTime = () => {
    var currentSeconds =
      (Math.floor(refAudio.current.currentTime % 60) < 10 ? "0" : "") +
      Math.floor(refAudio.current.currentTime % 60);
    var currentMinutes = Math.floor(refAudio.current.currentTime / 60);
    setTimePlayer(
      Math.floor(refAudio.current.duration / 60) +
        ":" +
        (Math.floor(refAudio.current.duration % 60) < 10 ? "0" : "") +
        Math.floor(refAudio.current.duration % 60) +
        " / " +
        currentMinutes +
        ":" +
        currentSeconds
    );
    var percentageOfSong =
      refAudio?.current?.currentTime / refAudio?.current?.duration;

    var percentageOfSlider = song?.current?.offsetWidth * percentageOfSong;
    var percentageOfSlider2 = song2?.current?.offsetWidth * percentageOfSong;

    line.current.style.width = Math.round(percentageOfSlider) + "px";
    line2.current.style.width = Math.round(percentageOfSlider2) + "px";
  };

  const setLocation = (percentage) => {
    refAudio.current.currentTime = refAudio.current.duration * percentage;
  };

  const setSongPosition = (e) => {
    var songSliderWidth = e.target.offsetWidth;
    var evtobj = window.event ? window.event : e;
    let clickLocation = evtobj.layerX - e.target.offsetLeft;
    var percentage = clickLocation / songSliderWidth;
    setLocation(percentage);
  };

  const next = () => {
    refAudio.current.currentTime += 5;
  };

  const pre = () => {
    refAudio.current.currentTime -= 5;
  };

  return (
    <div className="Audio">
      {window.outerWidth < 993 ? (
        <>
          <div className="Audio-res">
            <div className="Audio-player-inside-player-res" onClick={playPause}>
              <img
                src={
                  iconPlayer
                    ? "/imgs/Profile/Play-icon.svg"
                    : "/imgs/Profile/icon-pleyer.svg"
                }
                id="songPlayPause"
              />
            </div>
            <img
              onClick={changeVolume}
              id="volumeMeter"
              className="Audio-player-inside-volume-res"
              src={
                volumePlayer
                  ? "/imgs/Profile/Volume.svg"
                  : "/imgs/Profile/Volume-res.svg"
              }
            />
            <div className="Audio-player-inside-time" onClick={updateTime}>
              <p className="Audio-player-inside-time-time-text time-res number-font">
                {timePlayer}
              </p>
            </div>
            <div
              className="Audio-player-inside-line"
              onClick={(e) => setSongPosition(e)}
            >
              <div className="progress song" ref={song}>
                <div className="line" ref={line}></div>
              </div>
            </div>
          </div>
          {/* {window.outerWidth < 769 ? (
                        <div className="Audio-player" id="AudioPlayer">
                            <div className="Audio-player-inside">
                                <img
                                    onClick={changeVolume}
                                    id="volumeMeter"
                                    className="Audio-player-inside-volume"
                                    src={
                                        volumePlayer
                                            ? "/imgs/Profile/Volume.svg"
                                            : "/imgs/Profile/Volume-res.svg"
                                    }
                                />
                                <div
                                    className="Audio-player-inside-line"
                                    onClick={(e) => setSongPosition(e)}
                                >
                                    <div className="progress song" ref={song2}>
                                        <div className="line" ref={line2}></div>
                                    </div>
                                </div>
                                <div
                                    className="Audio-player-inside-time"
                                    onClick={updateTime}
                                >
                                    <p className="Audio-player-inside-time-time-text number-font">
                                        {timePlayer}
                                    </p>
                                </div>
                                <img
                                    className="Audio-player-inside-next"
                                    src="/imgs/Profile/forward-next.svg"
                                    onClick={next}
                                />

                                <div
                                    className="Audio-player-inside-player"
                                    onClick={playPause}
                                >
                                    <img
                                        src={
                                            iconPlayer
                                                ? "/imgs/Profile/Play-icon.svg"
                                                : "/imgs/Profile/icon-pleyer.svg"
                                        }
                                        id="songPlayPause"
                                    />
                                </div>
                                <img
                                    className="Audio-player-inside-pre"
                                    src="/imgs/Profile/forward-pre.svg"
                                    onClick={pre}
                                />
                            </div>
                        </div>
                    ) : null} */}
        </>
      ) : (
        <div className="Audio-podcast-inside-left">
          {/* <div className="Audio-podcast-inside-left-img">
                        <img
                            className="Audio-podcast-inside-left-img-svg"
                            src="/imgs/Profile/circle-player.svg"
                            onClick={playPause}
                        />
                    </div> */}
          <div className="Audio-podcast-inside-left-img">
            <div
              className="Audio-podcast-inside-left-img-player"
              onClick={playPause}
            >
              <img
                src={
                  iconPlayer
                    ? "/imgs/Profile/Play-icon.svg"
                    : "/imgs/Profile/icon-pleyer.svg"
                }
                id="songPlayPause"
              />
            </div>
          </div>

          <div className="Audio-player" id="AudioPlayer">
            <div className="Audio-player-inside">
              <img
                onClick={changeVolume}
                id="volumeMeter"
                className="Audio-player-inside-volume"
                src={
                  volumePlayer
                    ? "/imgs/Profile/Volume.svg"
                    : "/imgs/Profile/Volume-res.svg"
                }
              />
              <div
                className="Audio-player-inside-line"
                onClick={(e) => setSongPosition(e)}
              >
                <div className="progress song" ref={song}>
                  <div className="line" ref={line}></div>
                </div>
              </div>
              <div className="Audio-player-inside-time" onClick={updateTime}>
                <p className="Audio-player-inside-time-time-text number-font">
                  {timePlayer}
                </p>
              </div>
              <img
                className="Audio-player-inside-next"
                src="/imgs/Profile/forward-next.svg"
                onClick={next}
              />

              <div className="Audio-player-inside-player" onClick={playPause}>
                <img
                  src={
                    iconPlayer
                      ? "/imgs/Profile/Play-icon.svg"
                      : "/imgs/Profile/icon-pleyer.svg"
                  }
                  id="songPlayPause"
                />
              </div>
              <img
                className="Audio-player-inside-pre"
                src="/imgs/Profile/forward-pre.svg"
                onClick={pre}
              />
            </div>
          </div>
        </div>
      )}
      <audio
        onDurationChange={updateTime}
        onTimeUpdate={updateTime}
        src={audioSrc}
        hidden
        id="audio"
        ref={refAudio}
      />
    </div>
  );
};
export default Audio;
